import { render, staticRenderFns } from "./operateChannel.vue?vue&type=template&id=91329a3e&scoped=true"
import script from "./operateChannel.vue?vue&type=script&lang=js"
export * from "./operateChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91329a3e",
  null
  
)

export default component.exports